/* eslint-disable @typescript-eslint/naming-convention */
import React, { useMemo } from 'react';
import { getLocale, useIntl } from "umi";
import { cloneDeep } from 'lodash-es';
import { compare, getSystemColor } from '@/pages/dashboard/utils/utils';
import { getCountryFlag } from '@/pages/home/_config/countries';
import { getSystemFlag } from '@/pages/dashboard/pages/overview/_config/system';
import { usePcRevenueSelectorMap } from '@/pages/dashboard/filterPageComponents/monetization/hooks';
import dataFormat from '@home/utils/dbDataFormat/dataFormat';
import { formatPercent } from './_utils';

interface ITableColumnsProps {
  selectedMetrics: any;
  leftValue: string;
  rightValue: string;
  selector: any;
  // showLifeTimeRefund: boolean;
  title: string;
  sumValue: number;
}
export const useTableColumns = ( props: ITableColumnsProps) => {
  const {
    selectedMetrics,
    leftValue,
    rightValue,
    selector,
    // showLifeTimeRefund,
    title,
    sumValue
  } = props || {};
  const { formatMessage } = useIntl();
  const { getCountryCode } = usePcRevenueSelectorMap(selector);
  const isEn = getLocale() === 'en-US';
  const columns = useMemo(() => {

    const metricsKey = selectedMetrics?.resName || '';
    const isNotAccumated = selectedMetrics?.isNotAccumated;

    const columnsData = [
      {
        key: leftValue,
        header: formatMessage({ id: `common_${leftValue}` }),
        render: (cvm: any) => {
          let ImgDom: JSX.Element;
          const name = cvm.dimension_name?.[`${leftValue}_name_en`];
          let systemImgDom: JSX.Element;
          const isOther = name === 'Others';
          try {
            ImgDom = <img src={getCountryFlag(getCountryCode(name))} alt="flag" className='register-table-country-img' />;
          } catch (error) {
            ImgDom = <img src={getCountryFlag('undefined')} alt="flag" />;
          }
          try {
            systemImgDom = name?.toLowerCase()?.trim() === 'others' ? <></> :
              <img className='country-icon' src={getSystemFlag(name)} alt="flag" />;
          } catch (error) {
            systemImgDom = <img className='country-icon' src={getSystemFlag('undefined')} alt="flag" />;
          }

          return (
            <div className="dbd-sumNetRevenue-table-flex">
              {(leftValue === 'country' && !isOther) && ImgDom}
              {(leftValue === 'system' && !isOther) && systemImgDom}
              <span className="dbd-sumNetRevenue-table-text">
                {cvm.dimension_name?.[`${leftValue}_name_${isEn ? 'en' : 'cn'}`] || "-"}
              </span>
            </div>
          );
        },
      },
      {
        key: rightValue,
        header: formatMessage({ id: `common_${rightValue}` }),
        render: (cvm: any) => {
          let ImgDom: JSX.Element;
          const name = cvm.dimension_name?.[`${rightValue}_name_en`];
          let systemImgDom: JSX.Element;
          const isOther = name === 'Others';
          try {
            ImgDom = <img src={getCountryFlag(getCountryCode(name))} alt="flag" className='register-table-country-img' />;
          } catch (error) {
            ImgDom = <img src={getCountryFlag('undefined')} alt="flag" />;
          }
          try {
            systemImgDom = name?.toLowerCase()?.trim() === 'others' ? <></> :
              <img className='country-icon' src={getSystemFlag(name)} alt="flag" />;
          } catch (error) {
            systemImgDom = <img className='country-icon' src={getSystemFlag('undefined')} alt="flag" />;
          }
          return (
            <div className="dbd-sumNetRevenue-table-flex">
              {(rightValue === 'country' && !isOther) && ImgDom}
              {(rightValue === 'system' && !isOther) && systemImgDom}
              <span className="dbd-sumNetRevenue-table-text">
                {cvm.dimension_name?.[`${rightValue}_name_${isEn ? 'en' : 'cn'}`] || "-"}
              </span>
            </div>
          );
        },
      },
      {
        key: metricsKey,
        header: title,
        align: 'right',
        render: (cvm: any) => {
          // isNetDlcRevenue时指标为units_dlc_revenue保留两位小鼠
          // return segItem?.isPercent ? formatPercentNum(cvm?.metrics?.[metricsKey]?.value, 2)
          //  : formatNum(cvm?.metrics?.[metricsKey]?.value, false, segItem?.unit ? false : true)
          
          const dataValue = {
            value: cvm?.metrics?.[metricsKey]?.value,
            formatRule: selectedMetrics?.formatRule,
          };
          return dataFormat(dataValue);
        }
      },
    ];

    if(isNotAccumated) {
      return columnsData;
    }
    return [
      ...columnsData,
      {
        key: 'share',
        header: formatMessage({ id: `common_share` }),
        align: 'right',
        render: (cvm: any) => {
          // isNetDlcRevenue时指标为units_dlc_revenue保留两位小鼠
          // return segItem?.isPercent ? formatPercentNum(cvm?.metrics?.[metricsKey]?.value, 2)
          //  : formatNum(cvm?.metrics?.[metricsKey]?.value, false, segItem?.unit ? false : true)
          const val = cvm?.metrics?.[metricsKey]?.value;
          const dataValue = {
            value: sumValue ? val / sumValue : '',
            formatRule: selectedMetrics?.formatPercentRule || 'percent2Decimal',
          };
          return (sumValue && val !=='') ? formatPercent(dataValue) : '-';
        }
      },
    ];
  }, [leftValue, rightValue, selectedMetrics, isEn, sumValue]);
  return columns;
};

export const useTableDownLoad = (selectedMetrics:any, columns: any[], treeData: any[], leftValue: string, rightValue: string,sumValue: string) => {
  const isEn = getLocale() === 'en-US';

  const downloadConfig = useMemo(() => {
    const metricsKey = selectedMetrics?.resName || '';
    const downloadOptions = columns || [];
    const dowLoadData = treeData?.map((item: any) => {
      const val = item?.metrics?.[metricsKey]?.value;
      const excleValue = {
        value: val,
        formatRule: selectedMetrics?.formatRule,
      };
      const downloadObj = {
        [leftValue]: item.dimension_name?.[`${leftValue}_name_${isEn ? 'en' : 'cn'}`] || "-",
        [rightValue]: item.dimension_name?.[`${rightValue}_name_${isEn ? 'en' : 'cn'}`] || "-",
        [metricsKey]: dataFormat(excleValue), 
      };
      if(selectedMetrics?.isNotAccumated) {
        return downloadObj;
      }

      return {
        ...downloadObj, 
        share: (sumValue && val !== '') ? formatPercent({
          value: sumValue ? (val / sumValue) : '',
          formatRule: selectedMetrics?.formatPercentRule || 'percent2Decimal',
        }) : '-'
      };
      
    });
    return { downloadOptions, dowLoadData };
  }, [columns, treeData, selectedMetrics, leftValue, rightValue, isEn]);
  return downloadConfig;
};

export const useTreeData = (selectedMetrics:any, selector: any, tableData: any[], leftValue: string, rightValue: string,
  title: string, expandedData: any[],) => {
  const isEn = getLocale() === 'en-US';
  const { getCountryCode } = usePcRevenueSelectorMap(selector);
  const getSelectedDimension = (tableData: any[], dimension: string) => removeDuplicates(tableData?.map((item: any) => item?.dimension_name?.[`${dimension}_name_${isEn ? 'en' : 'cn'}`]) || []);
  // 当维度为国家的时候，颜色不够用，这里
  const generateTreeData = (leftDimension: string[], rightDimension: string[], key: string) => {

    const treeData: any = {
      name: title,
      depth: 1,
      value: '',
      children: [],
      collapsed: false,
      backgroundColor: '#7DADFF',
      colorFilledProcess: false,
    };
    const systemDataMap: any = {};
    const sumMoleculeValArr: number[] = [];
    const sumDenominatorValArr: number[] = [];
    tableData.forEach((data) => {
      if(selectedMetrics?.isNotAccumated) {
        sumMoleculeValArr?.push(parseFloat(data.metrics?.[selectedMetrics?.moleculeKey]?.value || 0));
        sumDenominatorValArr?.push(parseFloat(data.metrics?.[selectedMetrics?.denominatorKey]?.value || 0));
      }
      // 从输入数据中提取系统名和国家名：
      const leftDimensionName = data?.dimension_name?.[`${leftValue}_name_${isEn ? 'en' : 'cn'}`];
      const rightDimensionName = data?.dimension_name?.[`${rightValue}_name_${isEn ? 'en' : 'cn'}`];
      const leftDImensionEnName = data?.dimension_name?.[`${leftValue}_name_en`];
      const rightDimensionEnName = data?.dimension_name?.[`${rightValue}_name_en`];
      // 是否包含 systemName。如果包含，那么继续处理这一条数据，否则跳过。
      if (leftDimension.includes(leftDimensionName)) {
        // 检查 systemDataMap 是否已经有一个 leftDimensionName 属性。如果没有，就创建一个新的对象并赋值该属性
        // 如果已经有 leftDimensionName 属性了，说明其他的数据已经对其进行了部分初始化和赋值，所以这里就直接跳过。
        if (!Object.prototype.hasOwnProperty.call(systemDataMap, leftDimensionName)) {
          systemDataMap[leftDimensionName] = {
            name: leftDimensionName,
            depth: 2,
            value: 0,
            children: [],
            moleculeVal: 0,
            denominatorVal: 0,
            // parentSum:
            // 第一项默认展开
            // collapsed: index !== 0,
            // 产品确认只会有五个平台，固定五种颜色，others为设计稿上包含的，此处先添加上做兜底
            // 和后端确认后，id在测试和预发布可能会有变化，需要用系统的英文名称做key来对应(为防止配置时名称配置成小写，这里用小写为key)
            backgroundColor: leftValue === 'system' ? getSystemColor(leftDImensionEnName?.trim()?.toLowerCase()) : '#7DADFF',
            icon: getIcon(leftValue, leftDImensionEnName),
            colorFilledProcess: false,
          };
        }
        // 拿出当前的revenue值，进行叠加到systen的value中
        const revenue = parseFloat(data.metrics?.[key]?.value || 0);
        // moleculeVal和denominatorVal不能兜底为空，为空则无法进行累加计算
        systemDataMap[leftDimensionName].moleculeVal += parseFloat(data.metrics?.[selectedMetrics?.moleculeKey]?.value || 0);
        systemDataMap[leftDimensionName].denominatorVal += parseFloat(data.metrics?.[selectedMetrics?.denominatorKey]?.value || 0);
  
        // 是否直接累加，不是的话则取分子累加除以分母
        // 后后端确认逻辑后，refund_rate为：accumulated_chargeback_units累加 /  accumulated_gross_units累加
        // ASP为：gross_revenue累加/ gross_units_online累加
        if (selectedMetrics?.isNotAccumated) {
          systemDataMap[leftDimensionName].value = systemDataMap[leftDimensionName].denominatorVal ? (systemDataMap[leftDimensionName].moleculeVal / systemDataMap[leftDimensionName].denominatorVal) : '';
          systemDataMap[leftDimensionName].colorFilledProcess = true;
        } else {
          systemDataMap[leftDimensionName].value += revenue;
        }
        // 是否包含 countryName。如果包含，那么继续处理，否则跳过。
        if (rightDimension.includes(rightDimensionName)) {
          // 如果找不到（findIndex 返回 -1），那么就在 children 数组中添加一个新的国家数据，
          // value 是这次的 revenue。否则，就找到对应国家并在其 value 上加上这次的 revenue。
          const countryIndex = systemDataMap[leftDimensionName].children.findIndex(
            (child: { name: any; }) => child.name === rightDimensionName
          );
          if (countryIndex === -1) {
            systemDataMap[leftDimensionName].children.push({
              name: rightDimensionName,
              depth: 3,
              value: revenue,
              // 产品确认只会有五个平台，固定五种颜色，others为设计稿上包含的，此处先添加上做兜底
              // 和后端确认后，id在测试和预发布可能会有变化，需要用系统的英文名称做key来对应(为防止配置时名称配置成小写，这里用小写为key)
              backgroundColor: rightValue === 'system' ? getSystemColor(rightDimensionEnName?.trim()?.toLowerCase()) : '#7DADFF',
              icon: getIcon(rightValue, rightDimensionEnName),
              colorFilledProcess: selectedMetrics?.isNotAccumated || false,
              moleculeVal: 0,
              denominatorVal: 0,
            });
          } else {
            systemDataMap[leftDimensionName].children[countryIndex].value += revenue;
          }
        }
      }
    });
    // 使用 Object.values 函数将 systemDataMap 对象转为数组
    // 然后赋值给 treeData.children，这样 treeData 的每个 children 就是一个系统数据。

    if(selectedMetrics?.isNotAccumated) {
      const sumMoleculeVal = sumMoleculeValArr.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
      const sumDenominatorVal= sumDenominatorValArr.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
      treeData.value = (!sumDenominatorVal) ? '' : sumMoleculeVal/sumDenominatorVal;
    } else {
      treeData.value = Object.values(systemDataMap).reduce(
        (total: number, sys: any) => total + (sys as { value: number; }).value,0
      );
    }

   
    treeData.children = Object.values(systemDataMap);
    const filteredTreeData = { ...treeData };
    // 过滤掉为0或者为空的数据
    filteredTreeData.children = filteredTreeData.children.map((item: any) => {
      const filteredChildren = item.children.filter((childrenItem: any) => childrenItem.value !== 0 && childrenItem.value !== '' && childrenItem.value !== null);
      return { ...item, children: filteredChildren };
    }).map((system: any) => {
      const filteredChildren = system.children.filter((country: any) => country.value !== '');
      return { ...system, children: filteredChildren };
    }).filter((system: any) => system.children.length > 0);
    return filteredTreeData;
  };


  const sortData = (data: any, parentValue = 0) => {
    const {value} = data;
    // const valueShow = selectedMetrics?.isPercent ? (value < 0 ? `-${formatPercentNum(data.value)}` : formatPercentNum(data.value)) : formatNum(data.value, false, selectedMetrics?.isUserType);
    const dataValue = {
      value,
      formatRule: selectedMetrics?.formatRule,
    };
    const valueShow = dataFormat(dataValue);
    const hidePercent = selectedMetrics?.hideBarPercent ?? false;
    const newNode = {
      ...data,
      valueShow,
      hidePercent,
      sumValue: parentValue
    };

    if (data.children) {
      newNode.children = (data.children.map((child: any) => sortData(child, data.value)) || [])?.sort(compare('value'));
    }
    return newNode;
  };

  const addCollapsedProperties = (data: any, level = 0, index = 0) => {
    if (!data) return;
    const newData = {
      ...data,
      collapsed: !(level <= 1 && index === 0),
    };
    if (data.children) {
      newData.children = data.children.map((child: any, index: number) => addCollapsedProperties(child, level + 1, index));
    }

    return newData;
  };

  const formatData = (data: any, parentValue: number) => {
    let result = sortData(data, parentValue);
    result = addCollapsedProperties(result, 0, 0);
    return result;
  };

  const getIcon = (type: string, name: string) => {
    if (type === 'system') {
      return getSystemFlag(name);
    }
    if (type === 'country') {
      return getCountryFlag(getCountryCode(name));
    }
    return null;
  };

  const treeData = useMemo(() => {
    const leftDimension = getSelectedDimension(tableData, leftValue);
    const rightDimension = getSelectedDimension(tableData, rightValue);

    const metricsKey = selectedMetrics?.resName || '';

    const dataResult = generateTreeData(leftDimension, rightDimension, metricsKey);
    return formatData(dataResult, dataResult?.value);
  }, [tableData, leftValue, rightValue, isEn]);

  const treeDataList = useMemo(() => {
    const treeDataList = cloneDeep(treeData);
    const expandedDataName = expandedData?.[0]?.name || '';
    const isHaveNameItem = treeDataList?.children?.filter((item: { name: string; }) => item.name === expandedDataName)?.length > 0;

    if (isHaveNameItem) {
      treeDataList?.children?.forEach((item: { name: string; collapsed: boolean; }) => {
        if (item?.name === expandedDataName) {
          item.collapsed = expandedData?.[0]?.collapsed;
        } else {
          item.collapsed = true;
        }
      });
    }
    return treeDataList;
  }, [JSON.stringify(treeData), JSON.stringify(expandedData)]);

  return treeDataList;
};

const removeDuplicates = (arr: any[]) => [...new Set(arr)];
